import React, { useState } from 'react'
import PropTypes from 'prop-types'
import MultiSelect from '../../../internal/MultiSelect'
import { getText } from '../../../internal/TextLabels'
import { getRoleIds, getRoleNames } from '../../../models/roles'

const NewsFormRole = ({ newsRoles, onChange, fieldName, fieldCaption }) => {
  const [selectedRoleIds, setSelectedRoleIds] = useState(
    newsRoles.map(r => r.id),
  )

  const onRolesChanged = values => {
    setSelectedRoleIds(values)
    onChange(values)
  }

  return (
    <MultiSelect
      fieldName={fieldName}
      fieldCaption={fieldCaption}
      values={getRoleIds()}
      defaultValues={selectedRoleIds}
      multiple
      names={getRoleNames()}
      addText={getText('news.add.recipientSection.addRole')}
      onChange={onRolesChanged}
      round
      hideButton
    />
  )
}

NewsFormRole.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldCaption: PropTypes.string.isRequired,
  newsRoles: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default NewsFormRole
